import { atom } from "recoil";

import { DrawerType, IDrawer } from "../../models";

export const drawersAtom = atom<IDrawer<DrawerType>[]>({
  key: "drawersAtom",
  default: [],
});
